import { AccountNumberInput } from '@/feature/account/components/account-number-input/AccountNumberInput.client'
import { SubmitButton } from './action/submit/SubmitButton'
import type { FormProps } from './Form.client'
import { Form as OriginalForm } from './Form.client'
import { CheckboxInput } from './inputs/checkbox/CheckboxInput.client'
import { TermsCheckboxInput } from './inputs/checkbox/TermsCheckbox.client'
import { EmailInput } from './inputs/email/EmailInput.client'
import { DropZoneInput } from './inputs/file-upload/DropZoneInput.client'
import { HiddenInput } from './inputs/hidden/HiddenInput'
import { NumberInput } from './inputs/number/NumberInput.client'
import { RadioCardGroup } from './inputs/radio-card/RadioCardGroup.client'
import { RadioGroup } from './inputs/radio/RadioGroup.client'
import { SearchInput } from './inputs/search/SearchInput.client'
import { Toggle } from './inputs/switch/Toggle.client'
import { TextInput } from './inputs/text/TextInput.client'
import { TextAreaInput } from './inputs/textarea/TextAreaInput.client'

function Form<T extends object>(props: FormProps<T>) {
  return <OriginalForm {...props} />
}

Form.Input = {
  AccountNumber: AccountNumberInput,
  Checkbox: CheckboxInput,
  Dropzone: DropZoneInput,
  Email: EmailInput,
  Hidden: HiddenInput,
  Number: NumberInput,
  Radio: RadioGroup,
  RadioCard: RadioCardGroup,
  Search: SearchInput,
  Toggle,
  Terms: TermsCheckboxInput,
  Text: TextInput,
  Textarea: TextAreaInput,
}

Form.Action = {
  Submit: SubmitButton,
}

export { Form }
